import Vue from 'vue';
import Component from 'vue-class-component';
import { modalHelper, DataItemStatus } from '@/components/modal/modalHelper';
import { Async } from '@/utils/AsyncDecorators';
import { Watch } from 'vue-property-decorator';
import Form from "./form.vue";
import { areaSaggioClasseDiametricaStore } from '../store/areaSaggioClasseDiametrica.store';
import { versioneInSituStore } from '@/modules/VersioneInSitu/store/VersioneInSitu.store';
import { areaSaggioStore } from '@/modules/AreaSaggio/store/areaSaggio.store';
import { store } from '@/store';
import { layoutHelper } from '@/helpers/LayoutHelper';
import { domainStore } from '@/modules/domains';
import { replaceInArray } from '@/utils/Array';
import { localVersionHelper } from '@/helpers/LocalVersionHelper';
import { Guid } from 'guid-typescript';
import { reportStore } from '@/modules/Reports/store/report.store';

Vue.component("classe-diametrica-row", () => !layoutHelper.isWeb ? import("./mobile/classeDiametricaRow.vue") : import("./web/classeDiametricaRow.vue"));

@Component({})
export default class Index extends Vue {
  showSearchBar: boolean = false;

  @Async({ async get() { return (await areaSaggioStore.getters.getAll()).sort((a, b) => a.nome.localeCompare(b.nome)); }, default: [], lazy: false })
  storeSaggio: server.areaSaggio[];

  @Async({ async get() { return await areaSaggioClasseDiametricaStore.getters.getAll() }, default: [], lazy: true })
  areeSaggioClasseDiametrica: server.areaSaggioClasseDiametrica[];

  @Async({ async get() { return await versioneInSituStore.getters.current() }, default: {}, lazy: false })
  currentVersion: server.VersioneInSitu;

  @Async({ async get() { return await (await domainStore.getters.specieArboree()) }, default: [], lazy: true })
  specieArboree: domains.domini[];

  get areeSaggio() {
    return this.storeSaggio.map((m) => {
      return {
        key: m.id,
        value: m.id,
        description: m.nome,
      } as server.autocomplete
    })
  }

  get areaSaggioId() {
    return store.getters.navigation.selected("areaSaggio");
  }
  get navigation() {
    if (!this.areaSaggioId) return null;
    return this.areeSaggio.find(f => f.key === this.areaSaggioId) || {} as server.autocomplete;
  }
  set navigation(value: server.autocomplete) {
    if (value.key !== this.areaSaggioId) {
      store.actions.navigation.set_filter({ area: "areaSaggio", id: value ? value.key : null });
      reportStore.actions.set_logarithmic_regression(value ? value.key : null);
      this.selected = null;
    }
  }

  filter = {
    text: "",
  };

  get areeSaggioClassiDiametriche(): server.areaSaggioClasseDiametrica[] {
    if (!this.areaSaggioId) return [];
    return this.areeSaggioClasseDiametrica.filter(i => i.areaSaggioId === this.areaSaggioId);
  }

  @Watch('filter.text')
  change(n, o) { this.showsize = 20; }
  showsize: number = 20;

  get classiDiametriche(): number[] {
    const classiDimateriche = this.areeSaggioClassiDiametriche.sort((a, b) => a.diametro - b.diametro).map(m => m.diametro);
    return [...new Set(classiDimateriche)];
  }

  get classiDiametricheResized(): number[] {
    return this.classiDiametriche.slice(0, this.showsize);
  }

  get specieArboreeSelezionateIds(): number[] {
    const specieArboree = this.areeSaggioClassiDiametriche.sort((a, b) => a.specieOrderIndex - b.specieOrderIndex).map(m => m.specie);
    const uniqueValues = [...new Set(specieArboree)]
    return uniqueValues;
  };

  get specieArboreeInserite(): domains.domini[] {
    if ((this.specieArboree || []).length <= 0 || (this.specieArboreeSelezionateIds || []).length <= 0) return [];
    const result: domains.domini[] = [];
    this.specieArboreeSelezionateIds.forEach(m => {
      const specie = this.specieArboree.find(f => f.id === m)
      if (specie) result.push(specie);
    })
    return result;
  }

  get rowCells(): any {
    if (this.areeSaggioClassiDiametriche.length <= 0 || this.specieArboreeSelezionateIds.length <= 0) return {};

    const result = {};
    this.classiDiametricheResized.forEach(classeDiametrica => {
      result[classeDiametrica] = this.specieArboreeSelezionateIds.map((specieArborea) => {
        let elem = this.areeSaggioClassiDiametriche.find(f => f.diametro == classeDiametrica && f.specie === specieArborea);
        if (elem) return elem;
        elem = {
          id: Guid.create().toString(),
          versioneId: this.currentVersion.id,
          areaSaggioId: this.areaSaggioId,
          specie: specieArborea,
          diametro: classeDiametrica,
          contatore: 0
        } as server.areaSaggioClasseDiametrica
        areaSaggioClasseDiametricaStore.actions.setAreaSaggioClasseDiametrica(elem);
      })
    })
    
    return result;
  }

  async edit() {
    let _specieArboree = this.specieArboreeSelezionateIds;
    if (!_specieArboree || _specieArboree.length <= 0) {
      //nel caso in cui non ci sono classi diametriche imposto le specie dell'area di saggio
      _specieArboree = this.storeSaggio.find(f => f.id === this.areaSaggioId)?.speciePresenti || [];
    }

    let _specieArboreeAreaSaggio = this.storeSaggio.find(f => f.id === this.areaSaggioId)?.speciePresenti || [];
    _specieArboree = _specieArboree.filter((value) => _specieArboreeAreaSaggio.includes(value));

    const rilievo = {
      versioneId: this.currentVersion.id,
      areaSaggioId: this.areaSaggioId,
      specieArboree: _specieArboree,
      specieArboreePresenti: _specieArboreeAreaSaggio,
      classiDiametriche: this.classiDiametriche || [],
      rilevamenti: this.areeSaggioClassiDiametriche
    };
    let result = await modalHelper.showModal<server.areaSaggioClasseDiametrica[]>(Form, rilievo);
    if (result.status === DataItemStatus.changed) {
      const items = this.areeSaggioClasseDiametrica.filter(f => f.areaSaggioId !== this.areaSaggioId);
      this.areeSaggioClasseDiametrica = items.concat(result.item || []);
    }
  }

  async add() {
    let _specieArboreeAreaSaggio = this.storeSaggio.find(f => f.id === this.areaSaggioId)?.speciePresenti || [];
    let _specieArboree = this.specieArboreeSelezionateIds;
    if (!_specieArboree || _specieArboree.length <= 0) {
      //nel caso in cui non ci sono classi diametriche imposto le specie dell'area di saggio
      _specieArboree = _specieArboreeAreaSaggio;
    }


    let result = await modalHelper.showModal<server.areaSaggioClasseDiametrica[]>(Form, {
      versioneId: this.currentVersion.id,
      areaSaggioId: this.areaSaggioId,
      specieArboree: _specieArboree,
      specieArboreePresenti: _specieArboreeAreaSaggio,
      classiDiametriche: this.classiDiametriche || [],
      rilevamenti: []
    });
    if (result.status === DataItemStatus.changed) {
      const items = this.areeSaggioClasseDiametrica.filter(f => f.areaSaggioId !== this.areaSaggioId);
      this.areeSaggioClasseDiametrica = items.concat(result.item);
    }
  }

  selected: server.areaSaggioClasseDiametrica = null;
  async select(item: server.areaSaggioClasseDiametrica) {
    this.selected = item;
  }

  async increases() {
    if (this.selected) {
      this.selected.contatore++
      await areaSaggioClasseDiametricaStore.actions.setAreaSaggioClasseDiametrica(this.selected);
      replaceInArray([this.selected], this.areeSaggioClasseDiametrica, (a, b) => a.id == b.id);
    }
  }

  async decreases() {
    if (this.selected && this.selected.contatore > 0) {
      this.selected.contatore--
      await areaSaggioClasseDiametricaStore.actions.setAreaSaggioClasseDiametrica(this.selected);
      replaceInArray([this.selected], this.areeSaggioClasseDiametrica, (a, b) => a.id == b.id);
    }
  }

  onShow() {
    return localVersionHelper.get("InSitu") ? true : false
  }
}